import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import '~/styles/main.scss';
import OwnersResourcesLandingPage from '.';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.OwnersResourcesLandingPage = OwnersResourcesLandingPage;
